class ErrorController {
  constructor ($stateParams) {
    'ngInject'
    this.errorCode = '0'
    if ($stateParams.errorCode !== undefined) {
      this.errorCode = $stateParams.errorCode
    }
  }
}

export default ErrorController



// WEBPACK FOOTER //
// ./src/app/pages/error/error.controller.js